import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  position: relative;
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

export const WarningIcon = styled.div`
  height: 20px;
  width: 20px;
  position: absolute;
  bottom: 13px;
  right: 20px;
`;

export const WarningText = styled.span`
  color: var(--danger);
  font-weight: 500;
  font-size: 12px;
  text-align: right;
  animation: wiggle 0.8s;

  @keyframes wiggle {
    0% {
      transform: translateX(0px);
    }
    33% {
      transform: translateX(10px);
    }
    66% {
      transform: translateX(-10px);
    }
    100% {
      transform: translateX(0px);
    }
  }
`;

export const Label = styled.label`
  font-weight: 500;
  font-size: 14px;
  line-height: 19px;
  color: var(--black-2);
`;

interface InputElementProps {
  isErrored: boolean;
}

export const InputElement = styled.input<InputElementProps>`
  width: 100%;
  height: 45px;
  font-size: 16px;
  padding: 15px 20px;
  color: var(--black-2);
  background: var(--white);
  border: 1px solid var(--gray-d);
  ${props =>
    props.isErrored &&
    css`
      border-color: var(--danger);
    `}
  border-radius: 4px;
  margin-top: 10px;
  outline: 0;
  transition: 0.2s ease-in-out;

  :focus {
    border: 1px solid var(--primary);
  }

  :disabled {
    background: var(--white-darker);
    cursor: not-allowed;
  }
  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  [type='number'] {
    -moz-appearance: textfield;
  }
`;
